import * as types from './mutation-types'

export default {
    [types.FORMS_TYPES_SUCCESS] (state, data) {
        state.formTypes = data
    },
}
